import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";


//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "components/_Common/withRouter";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addAspirationQuestion, editAspirationQuestion } from "store/actions";
import { withTranslation } from "react-i18next";


const AddEditModal = props => {
    const { modal, toggle, isEdit, itemData, fetchQuestionListData } = props
    const [questionData, setQuestionData] = useState();
    const { error, success, loading,editLoading } = useSelector(state => ({
        loading: state.AspirationQuestion.loading,
        error: state.AspirationQuestion.error,
        success: state.AspirationQuestion.success,
        editLoading:state.AspirationQuestion.editLoading
    }));
    const dispatch = useDispatch();

    useEffect(() => {
        setQuestionData(itemData)
    }, [itemData])
    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            question: questionData?.question || '',
            question_type: questionData?.question_type || 'radio',
            is_active: questionData?.is_active || 'Y'
        },
        validationSchema: Yup.object({

            question: Yup.string().required(`${props.t("Please Enter Your Concept")}`),
            question_type: Yup.string().required(`${props.t("Please Enter Your Question Type")}`),
            is_active: Yup.string().required(`${props.t("Please Enter Question Status")}`),
        }),
        onSubmit: (values, { resetForm, setFieldValue }) => {
            if (isEdit) {
                dispatch(editAspirationQuestion(values, questionData?.id, (res) => {
                    if (res.status === 'success') {
                        toastr.success(res.message)
                        // setQuestionData({})
                        resetForm({
                            question: '',
                            question_type: '',
                            is_active: 'Y'
                        });
                        toggle()

                        fetchQuestionListData()

                    } else {
                        toastr.error(res.message)
                        toggle()
                        // setQuestionData({})
                    }
                }));
            } else {
                dispatch(addAspirationQuestion(values, props?.router?.navigate, (res) => {
                    if (res?.status === 'success') {
                        toastr.success(res.message)
                        // setQuestionData({})
                        resetForm({
                            question: '',
                            question_type: '',
                            is_active: ''
                        });
                        toggle()
                        fetchQuestionListData()
                    } else {
                        toastr.error(res.message)
                        toggle()
                        // setQuestionData({})

                    }
                }));
            }

        }
    });



    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()
                    // setQuestionData({})
                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()
                        // setQuestionData({})
                    }}>
                    {!!isEdit ? props.t("Edit Aspiration") : props.t("Add Aspiration")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >

                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Concept")}:</Label>
                            <Input
                                name="question"
                                className="form-control"
                                placeholder={props.t("Enter Concept")}
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.question || ""}
                                invalid={
                                    validation.touched.question && validation.errors.question ? true : false
                                }
                            />
                            {validation.touched.question && validation.errors.question ? (
                                <FormFeedback type="invalid">{validation.errors.question}</FormFeedback>
                            ) : null}
                        </div>

                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Type")}:</Label>

                            <Input
                                type="select"
                                name="question_type"
                                value={validation.values.question_type || ""}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.question_type && validation.errors.question_type ? true : false}
                            >
                                <option value="" disabled>{props.t("Select Question Type")}</option>
                                <option value="radio">{props.t("Radio")}</option>
                                <option value="textarea">{props.t("Textarea")}</option>
                            </Input>

                            {validation.touched.question_type && validation.errors.question_type ? (
                                <FormFeedback type="invalid">{validation.errors.question_type}</FormFeedback>
                            ) : null}
                        </div>
                        <div className="mb-3 d-flex align-items-center gap-3">
                            <Label className="form-label m-0">{props.t("Status")}:</Label>
                            <div className="d-flex align-items-center gap-2">
                                <Input
                                    id="yes"
                                    name="is_active"
                                    type="radio"
                                    checked={validation.values.is_active == 'Y'}
                                    value="Y"
                                    onClick={(e) => {
                                        validation.setFieldValue('is_active', e.target.value);
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="yes" className="form-label m-0">{props.t("Active")}</Label>
                                <Input
                                    id="no"
                                    name="is_active"
                                    checked={validation.values.is_active === 'N'}
                                    value="N"
                                    type="radio"
                                    onClick={(e) => {
                                        validation.setFieldValue('is_active', e.target.value);
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="no" className="form-label m-0">{props.t("In-Active")}</Label>

                            </div>
                            {validation.touched.is_active && validation.errors.is_active ? (
                                <FormFeedback type="invalid">{validation.errors.is_active}</FormFeedback>
                            ) : null}
                        </div>

                        {
                            editLoading ?
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block d-flex"
                                        disabled
                                    >
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                        {props.t("Submit")}
                                    </button>
                                </div>
                                :
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                    // disabled
                                    >
                                        {props.t("Submit")}
                                    </button>
                                </div>
                        }
                    </Form>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};


AddEditModal.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(AddEditModal);

